<app-configuration-page
  title="FAQ"
  description="Short, practical guides for everyday Agenda Master tasks."
  [breadcrumbs]="[{ label: 'FAQ' }]">

  <ng-container configPageActions>
    <button mat-stroked-button color="primary" (click)="openFaqDoc()">
      <mat-icon>description</mat-icon>
      FAQ Document
    </button>
    <button mat-stroked-button color="primary" (click)="openKnowledgeBase()">
      <mat-icon>library_books</mat-icon>
      Knowledge Base
    </button>
  </ng-container>

  <!-- Working Area -->
  <div class="row g-3">
    <!-- Sidebar Nav -->
    <aside class="col-12 col-md-4 col-lg-3">
      <div class="card shadow-sm border-0">
        <div class="card-header bg-white border-bottom">
          <div class="small text-uppercase text-muted fw-semibold">Topics</div>
        </div>
        <div class="list-group list-group-flush">
          <button type="button"
                  *ngFor="let category of categories"
                  (click)="selectCategory(category)"
                  [class.active]="selectedCategory === category"
                  class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
            <span><span class="me-2">{{ category.icon }}</span>{{ category.name }}</span>
            <span class="badge bg-secondary bg-opacity-25 text-dark rounded-pill">{{ category.items.length }}</span>
          </button>
        </div>
      </div>
    </aside>

    <!-- Main Panel -->
    <main class="col-12 col-md-8 col-lg-9">
      <div class="card shadow-sm border-0">
        <div class="card-header bg-white border-bottom d-flex flex-wrap justify-content-between align-items-center gap-2">
          <div>
            <h2 class="h5 mb-0">{{ selectedCategory.name }}</h2>
            <div class="text-muted small">{{ selectedCategory.items.length }} questions</div>
          </div>
        </div>

        <div class="accordion accordion-flush" id="faqAccordion">
          <div class="accordion-item"
               *ngFor="let item of selectedCategory.items; let i = index">
            <h3 class="accordion-header">
              <button class="accordion-button"
                      [class.collapsed]="!isExpanded(i)"
                      type="button"
                      (click)="toggleItem(i)">
                {{ item.question }}
              </button>
            </h3>
            <div class="accordion-collapse collapse" [class.show]="isExpanded(i)">
              <div class="accordion-body">
                <p class="mb-3" [innerHTML]="item.answer | nl2br"></p>
                <div class="d-flex flex-wrap gap-2" *ngIf="item.videoLinks && item.videoLinks.length > 0">
                  <a *ngFor="let link of item.videoLinks"
                     [href]="link.url"
                     target="_blank"
                     rel="noreferrer"
                     mat-stroked-button
                     color="primary">
                    <mat-icon>play_circle</mat-icon>
                    {{ link.label }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Help Footer -->
      <div class="card shadow-sm border-0 mt-3">
        <div class="card-body d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div>
            <h3 class="h6 mb-1">Can't find what you need?</h3>
            <p class="text-muted small mb-0">Browse the full Knowledge Base for detailed walkthroughs and documentation.</p>
          </div>
          <button mat-raised-button color="primary" (click)="openKnowledgeBase()">
            <mat-icon>library_books</mat-icon>
            Open Knowledge Base
          </button>
        </div>
      </div>
    </main>
  </div>

</app-configuration-page>
